// // ** Styles
// import '@styles/react/apps/app-users.scss'
// import axios from "axios"
// // useState, useEffect,
// import {  useState, useEffect } from 'react'
// import "flatpickr/dist/themes/material_green.css"

// const [post, setPost] = useState([])
//  const companyID = JSON.parse(localStorage.getItem('companyID'))
// const baseURL = "https://api.zasway.com:8443/Common/TaxList"

// function createPost() {
//     
//   axios.post(baseURL, {
//   companyID
//   })
//     .then((response) => {
//         
//       setPost(response.data)
//       console.log(response.data)
//     })
// }


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
export const getTaxList = createAsyncThunk('appDriversLocation/getTaxList', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/TaxList', params, { mode: 'cors' })
  
    return response.data
})

export const getData = createAsyncThunk('Client/getData', async (params) => {
     
       const response = await axios.post('https://api.zasway.com:8443/Common/GetTableSummary', params, {mode:'cors'})
        
       return {
         params,
         data: response.data.data,
         allData: response.data.allData,
         totalPages: response.data.total
       }
  
 })

export const appTaxlistSlice = createSlice({
    name: 'appTaxlist',
    initialState: {
        data: [],
        //allData: [],
        taxlist: [],
        data: [],
        total: 1,
        params: {},
        allData: [],
        selectedUser: null,
        selectedDocument:[],
        IsSaved:0

    },
    reducers: {},
    extraReducers: builder => {
        builder
            // .addCase(getTaxList.fulfilled, (state, action) => {
            //      
            //     // state.allData = action.payload.allData
            //     // state.data = action.payload.data
            //     state.taxlist = action.payload
            // })
            .addCase(getData.fulfilled, (state, action) => {
         
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.totalPages
              })
    }
})
export default appTaxlistSlice.reducer